<div class="title-bar"
     [ngClass]="{
         'pl-2': isSecondary,
         'title-bar--top' : isTop
        }">
  <div class="title-bar__main">
    <div class="title-bar__title-area">
      @if (showBack && hasHistory()) {
        <button class="btn btn-auto btn-link btn-back"
          (click)="back()"
          >
          <sb-icon name="arrow-left"
          class="text-muted"></sb-icon>
        </button>
      }
      <h3 class="title-bar__title"
        [ngClass]="isSecondary ? 'p-15' : 'p-large'">
        <ng-content></ng-content>
        <span [innerHTML]="barTitle | translate"
        [ngClass]="{'hidden-xs' : barTitleXs}"></span>
        @if (barTitleXs) {
          <span [innerHTML]="barTitleXs | translate"
          class="hidden-lg hidden-md hidden-sm"></span>
        }
        @if (denominator) {
          <span
            class="ml-3 text-muted normal">
            @if (numerator !== undefined) {
              <span>{{numerator}} / </span>
            }
            <span [innerHTML]="denominator"></span>
          </span>
        }
      </h3>
    </div>
    <div class="title-bar__utility">
      @for (button of buttons; track button; let i = $index) {
        <sb-button
          [buttonClass]="button.buttonClass || 'link'"
          [customClasses]="button.customClasses"
          [iconName]="button.iconName"
          [message]="button.message"
          [xsIconOnly]="button.xsIconOnly"
          iconStyle="regular"
          [isDisabled]="button.isDisabled"
          [id]="button.buttonId"
          [dropdownItems]="button.dropdownItems"
          [isLoading]="button.isLoading"
        (onClick)="buttonClick(i, $event)"></sb-button>
      }
    </div>
    <!-- <ng-content *ngIf="transcludeInline"></ng-content> -->
  </div>
  <div>
    @if (description) {
      <div class="title-bar__description"
        [innerHTML]="description | translate">
      </div>
    }
    <ng-content select="[titleBarBody]"></ng-content>
  </div>
  @if ((linkUrl || linkRoute) && linkText) {
    <div class="title-bar__link"
      (click)="openLink()">
      <button class="btn btn-link">
        <span [innerHTML]="linkText | translate"
        [ngClass]="{'hidden-xs' : linkTextXs}"></span>
        @if (linkTextXs) {
          <span
            [innerHTML]="linkTextXs | translate"
          class="visible-xs"></span>
        }
        <sb-icon name="chevronRight"
        class="ml-1"></sb-icon>
      </button>
    </div>
  }
</div>